import { render, staticRenderFns } from "./list-supplier-staff.vue?vue&type=template&id=5de7083c&"
import script from "./list-supplier-staff.vue?vue&type=script&lang=js&"
export * from "./list-supplier-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports